import { Trans, useTranslation } from 'react-i18next'

function WellnessLeagues() {
  const { t } = useTranslation()

  return (
    <div className="Wlns-leagues">
      <section className="bg-dark hero-bg position-relative section-pdn pt-8 bg-img-hero">
        <div className="container custom_container d-flex justify-content-start align-items-center p0 m-d-block pt-0 pt-lg-5">
          <div className="col-12 col-sm-6 col-md-6 col-lg-6">
            <h1 className="font-weight-semibold text-center text-lg-left hero-heading mt-5 no-br">
              <Trans>
                Wellness Leagues- <br />
                Simplify Wellness, <br />
                Amplify Results
              </Trans>
            </h1>
            <p className="hero-para font-weight-semibold no-br">
              <Trans>Personalized benchmarks, actionable insights, and motivated teams</Trans>
            </p>
            <div className="pl-0 col-12 col-md-7 mtb25 d-md-flex justify-content-between align-items-center">
              <a href={t(`/request-demo/`)} className="vfitcompanycta arrowbtn-img">
                <Trans>Book a Demo</Trans>
              </a>
            </div>
          </div>
          <div className="col-12 col-sm-6 col-md-6 col-lg-6">
            <div className="d-flex justify-content-center px-0">
              <img
                className="img-responsive h-100 img-lap"
                src="https://res.cloudinary.com/vantagecircle/image/upload/v1738146148/VantageFit/2025/Glap.png"
                alt="hero img"
                width={633}
                height={389}
                style={{ transform: 'scale(1.6) translateX(40px) translateY(75px)' }}
              />
            </div>
          </div>
        </div>
      </section>
      <section className="bg-dark hero-bg position-relative section-pdn pt-8 wht-r-leagues">
        <div className="container custom_container d-flex  justify-content-start align-items-center p0 m-d-block">
          <div className="col-12 col-sm-6 col-md-6 col-lg-6">
            <h1 className="font-weight-semibold hero-heading text-center text-lg-left mt-5 no-br">
              <Trans>What are Leagues?</Trans>
            </h1>
            <p className="hero-para font-weight-semibold no-br">
              <Trans>
                Leagues categorize employees into Gold, Silver, or Bronze tiers based on their <br /> daily step count.
                It helps track activity levels, encourage healthier habits, and <br /> create personalized challenges to
                boost participation.
              </Trans>
            </p>
          </div>
          <div className="col-12 col-sm-6 col-md-6 col-lg-6">
            <div className="d-flex justify-content-center justify-content-lg-center">
              <img
                width={400}
                className="img-responsive badge-img"
                src="https://res.cloudinary.com/vantagecircle/image/upload/v1738146148/VantageFit/2025/glowbdgs.png"
                alt="badges"
              />
            </div>
          </div>
        </div>
        <div className="container custom_container d-flex flex-column justify-content-center align-items-center mt-lg-5 pt-5">
          <div className="w-full text-center mt-5">
            <h1 className="text-center text-lg-left">
              <Trans>How Leagues Can Help?</Trans>
            </h1>
          </div>
          <div className="mt-5 row d-flex justify-content-center container custom_container">
            <div className="col-12 col-md-6 my-4">
              <div
                className="dark_box p-2 px-4 ml-md-5 mr-md-2 d-flex flex-column align-items-center"
                style={{ borderRadius: '15px' }}
              >
                <img
                  width="50"
                  height="50"
                  src="https://res.cloudinary.com/vantagecircle/image/upload/v1736249230/VantageFit/2025/Group_1.png"
                  alt="Healthier"
                  className="my-4"
                />
                <div className="text-center">
                  <h6 className="font-weight-bold no-br text-white p-0 m-0">
                    <Trans>Healthier Employees, Smarter Savings:</Trans>{' '}
                  </h6>
                  <p className="hero-para font-weight-semibold no-br">
                    <Trans>
                      Reduce insurance premiums by increasing the <br /> number of employees having higher activity
                      levels.
                    </Trans>
                  </p>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-6 my-4">
              <div
                className="dark_box p-2 px-4 mr-md-5 ml-md-2  d-flex flex-column align-items-center"
                style={{ borderRadius: '15px' }}
              >
                <img
                  width="50"
                  height="50"
                  src="https://res.cloudinary.com/vantagecircle/image/upload/v1736252536/VantageFit/2025/Group_2.png"
                  alt="Drive"
                  className="my-4"
                />
                <div className="text-center">
                  <h6 className="font-weight-bold no-br text-white p-0 m-0">
                    <Trans>Drive Preventive Wellness:</Trans>
                  </h6>
                  <p className="hero-para font-weight-semibold no-br">
                    <Trans>
                      Encourage movement with challenges and incentives, <br /> reducing employees with low activity
                      levels.
                    </Trans>
                  </p>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-6 my-4">
              <div
                className="dark_box p-2 px-4 ml-md-5 mr-md-2 d-flex flex-column align-items-center"
                style={{ borderRadius: '15px' }}
              >
                <img
                  width="50"
                  height="50"
                  src="https://res.cloudinary.com/vantagecircle/image/upload/v1736252639/VantageFit/2025/fi_893220.png"
                  alt="Snapshot"
                  className="my-4"
                />
                <div className="text-center">
                  <h6 className="font-weight-bold no-br text-white p-0 m-0">
                    <Trans>Snapshot Views:</Trans>
                  </h6>
                  <p className="hero-para font-weight-semibold no-br">
                    <Trans>
                      Instantly see current league distributions with pie <br /> charts, trends over time, and detailed
                      tables.
                    </Trans>
                  </p>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-6 my-4">
              <div
                className="dark_box p-2 px-4 mr-md-5 ml-md-2 d-flex flex-column align-items-center"
                style={{ borderRadius: '15px' }}
              >
                <img
                  width="100"
                  height="50"
                  src="https://res.cloudinary.com/vantagecircle/image/upload/v1736252536/VantageFit/2025/Group_439.png"
                  alt="Custom"
                  className="my-4"
                />
                <div className="text-center">
                  <h6 className="font-weight-bold no-br text-white p-0 m-0">
                    <Trans>Custom Challenges:</Trans>
                  </h6>
                  <p className="hero-para font-weight-semibold no-br">
                    <Trans>
                      Create tailored wellness challenges using league <br /> breakdowns to keep employees motivated.
                    </Trans>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="hero-bg pb-5 hwitwrks">
        <div className="container custom_container d-flex justify-content-start align-items-center p0 m-d-block my-5 ">
          <div class="container">
            <h1 class="text-center">
              <Trans>How It Works</Trans>
            </h1>
            <div class="row justify-content-around mt-5" style={{ maxWidth: '1000px' }}>
              <div className="col-12 col-lg-4 lg-img-bg mb-5 mb-md-0">
                <div className="league-content p-4">
                  <h6 className="font-weight-bold no-br text-white p-0 m-0 text-center text-lg-left">
                    <Trans>Employees Log Activity:</Trans>
                  </h6>
                  <p className="hero-para font-weight-semibold no-br m-0" style={{ position: 'inherit', zIndex: '1' }}>
                    <Trans>Employees use the Vantage Fit app to log their daily steps and movement.</Trans>
                  </p>
                </div>
              </div>
              <div className="col-12 col-lg-4 lg-img-bg arw2 mb-5 mb-md-0">
                <div className="league-content p-4">
                  <h6 className="font-weight-bold no-br text-white p-0 m-0 text-center text-lg-left">
                    <Trans>Leagues Assignment:</Trans>
                  </h6>
                  <p className="hero-para font-weight-semibold no-br m-0" style={{ position: 'inherit', zIndex: '1' }}>
                    <Trans>Employees are categorized into Gold, Silver, or Bronze leagues based</Trans>
                  </p>
                </div>
              </div>
              <div className="col-12 col-lg-4 lg-img-bg arw2 mb-5 mb-md-0">
                <div className="league-content p-4">
                  <h6 className="font-weight-bold no-br text-white p-0 m-0 text-center text-lg-left">
                    <Trans>Real-Time Dashboards:</Trans>
                  </h6>
                  <p className="hero-para font-weight-semibold no-br m-0" style={{ position: 'inherit', zIndex: '1' }}>
                    <Trans>HRs monitor league distributions via pie charts, trends, and detailed tables.</Trans>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="position-relative pl-0 pr-0">
        <div className="">
          <div className="feat_box shadow active_challenge features_0 ft-bg-clrs py-5">
            <div className="d-flex m-d-block justify-content-center align-items-center container custom_container p-5">
              <div className="col-12 col-md-6">
                <div className="col-12">
                  <div className="features-label red-font">
                    <Trans>Instant Insights</Trans>
                  </div>
                  <h2 className="font-weight-semibold py-2 section-heading">
                    <Trans>Real-Time Snapshots</Trans>
                  </h2>
                  <p className="section-para font-weight-normal no-br">
                    <Trans>
                      Get an at-a-glance pie chart showing the Gold, Silver, and <br /> Bronze distribution at any
                      moment.
                    </Trans>
                  </p>
                  <p className="section-para font-weight-normal no-br">
                    <Trans>Use instant insights to plan and adjust wellness initiatives in real time.</Trans>
                  </p>
                </div>
              </div>
              <div className="col-12 col-md-6 cta-img p-0">
                <div className="d-flex justify-content-center justify-content-lg-end px-0">
                  <img
                    className="img-responsive"
                    src={t(
                      `https://res.cloudinary.com/vantagecircle/image/upload/v1736311438/VantageFit/2025/tinified%20%2813%29%201/employee_distribution.png`
                    )}
                    loading="lazy"
                    alt="Instant Insights"
                    width="472"
                    height="412"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="feat_box shadow active_challenge features_0 ft-bg-clrs py-5">
            <div className="d-flex m-d-block justify-content-center align-items-center container custom_container p-5">
              <div className="col-12 col-md-6">
                <div className="col-12">
                  <div className="features-label green-font">
                    <Trans>Trend Analysis</Trans>
                  </div>
                  <h2 className="font-weight-semibold py-2 section-heading">
                    <Trans>Trends Over Time</Trans>
                  </h2>
                  <p className="section-para font-weight-normal no-br">
                    <Trans>
                      View history trends of league distributions to measure the impact of wellness initiatives.
                    </Trans>
                  </p>
                  <p className="section-para font-weight-normal no-br">
                    <Trans>Identify long-term improvement patterns and adjust benchmarks as needed.</Trans>
                  </p>
                </div>
              </div>
              <div className="col-12 col-md-6 cta-img p-0">
                <div className="d-flex justify-content-center justify-content-lg-end px-0">
                  <img
                    className="img-responsive"
                    src={t(
                      `https://res.cloudinary.com/vantagecircle/image/upload/v1736311438/VantageFit/2025/tinified%20%2813%29%201/league_treands.png`
                    )}
                    loading="lazy"
                    alt="Trend Analysis"
                    width="592"
                    height="428"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="feat_box shadow active_challenge features_0 ft-bg-clrs py-5">
            <div className="d-flex m-d-block justify-content-center align-items-center container custom_container p-5">
              <div className="col-12 col-md-6">
                <div className="col-12">
                  <div className="features-label orange-font">
                    <Trans>League Metrics</Trans>
                  </div>
                  <h2 className="font-weight-semibold py-2 section-heading">
                    <Trans>Tabular Insights</Trans>
                  </h2>
                  <p className="section-para font-weight-normal no-br">
                    <Trans>
                      Access detailed tabular data showing league breakdowns <br /> for individuals and teams.
                    </Trans>
                  </p>
                  <p className="section-para font-weight-normal no-br">
                    <Trans>Leverage this format to create data-driven, personalized challenges.</Trans>
                  </p>
                </div>
              </div>
              <div className="col-12 col-md-6 cta-img p-0">
                <div className="d-flex justify-content-center justify-content-lg-end px-0">
                  <img
                    className="img-responsive"
                    src={t(
                      `https://res.cloudinary.com/vantagecircle/image/upload/v1736311441/VantageFit/2025/tinified%20%2813%29%201/league_report.png`
                    )}
                    loading="lazy"
                    alt="Tabular Insights"
                    width="592"
                    height="476"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="feat_box shadow active_challenge features_0 ft-bg-clrs py-5">
            <div className="d-flex m-d-block justify-content-center align-items-center container custom_container p-5">
              <div className="col-12 col-md-6">
                <div className="col-12">
                  <div className="features-label red-font">
                    <Trans>Personalized Engagement</Trans>
                  </div>
                  <h2 className="font-weight-semibold py-2 section-heading">
                    <Trans>
                      Customizable <br /> Challenges & Incentives
                    </Trans>
                  </h2>
                  <p className="section-para font-weight-normal no-br">
                    <Trans>
                      Design targeted challenges based on league data to <br /> increase employee activity.
                    </Trans>
                  </p>
                  <p className="section-para font-weight-normal no-br">
                    <Trans>
                      Offer tailored incentives, such as tax benefits for Gold <br /> league achievers, to boost
                      engagement and participation.
                    </Trans>
                  </p>
                </div>
              </div>
              <div className="col-12 col-md-6 cta-img p-0">
                <div className="d-flex justify-content-center justify-content-lg-end px-0">
                  <img
                    className="img-responsive"
                    src={t(
                      `https://res.cloudinary.com/vantagecircle/image/upload/v1736937894/VantageFit/2025/tinified%20%2813%29%201/image_216.png`
                    )}
                    loading="lazy"
                    alt="Personalized Engagement"
                    width="452"
                    height="484"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="position-relative container">
        <div className="section-heading-top cursive">
          <h2 className="section-heading font-weight-bold text-center mb-4">
            <Trans i18nKey="subtextfeat12">
              <span className="charmonman green-clr">Transform Wellness</span>, One Step at a Time
            </Trans>
          </h2>
          <div className="section-para text-center">
            <Trans>
              Preventive health is the key to reducing long-term costs and boosting employee satisfaction. Leagues helps
              you unlock a healthier <br /> workforce while positively impacting your bottom line.
            </Trans>
          </div>
        </div>
      </section>
      <section className="bottom-feat-cta position-relative section-pdn-1 pt-8 feat_testi brad0">
        <div className="container custom_container d-flex justify-content-start align-items-center p0 m-d-block">
          <div className="col-12">
            <h2 className="font-weight-semibold section-heading text-center no-br">
              <Trans>Ready to Build a Healthier Workforce?</Trans>
            </h2>
            <p className="sub-para font-weight-normal text-center mb-5 text-white">
              <Trans>Start using Leagues today to track progress, drive health improvements, and save on costs.</Trans>
            </p>
            <div className="pl-0 col-12 mtb25 d-flex justify-content-center align-items-center">
              <a href={t(`/request-demo/`)} className="vfitcompanycta arrowbtn-img">
                <Trans>Book a Demo</Trans>
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default WellnessLeagues
